import React from "react";
import "./styles.css";
import Welcome from "../../welcome";
import Press from "../../press";
import ProductQuestions from "../../product-questions";
import Footer from "../../UI/footer";
import Blog from "../../blog";
import Plans from "../../plans";
import Usage from "../../usage";
import Analytics from "../../analytics";
import Features from "../../features";
import Demo from "../../demo";

function Home() {
  return (
    <div className="home">
      <Welcome />
      <Press title={"Prensa"} />
      <ProductQuestions />
      <Usage />
      <Demo />
      <Features />
      <Analytics />
      <Plans />
      <Blog title={"Recursos para tu negocio"} />
      <Footer />
    </div>
  );
}

export default Home;
